import { Chip, type ChipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { CaseCopyStatus } from "src/types";
import { caseCopyStatusBackgroundColor, caseCopyStatusTextColor } from "src/utils/case.utils";

type CaseCopyStatusChipProps = ChipProps & {
  status: CaseCopyStatus;
};

export const CaseCopyStatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "status",
})<CaseCopyStatusChipProps>`
  background-color: ${({ status }) => caseCopyStatusBackgroundColor(status)};
  color: ${({ status }) => caseCopyStatusTextColor(status)};
`;
